<template>
  <div>
    <div class="pay_type">
      <div class="pay_type_left">
        <img src="@/assets/order/wechart@2x.png" alt="" class="wechat_icon" />
        <span class="font12 font_weight400 colo0 line_height_17 wechat_font"
          >微信支付</span
        >
      </div>
      <img
        :src="choose ? select : unSelect"
        alt=""
        class="select_icon"
        @click="clickChoose"
      />
    </div>

    <!-- 底部悬浮的确认支付按钮 -->
    <div class="bottom_btn_wrap">
      <div
        class="save_btn font_weight500 font14 colof line_height_20"
        @click="goPay"
      >
        确认支付
      </div>
    </div>
  </div>
</template>

<script>
const wx = require("jweixin-module");
import { v1 as uuidv1 } from "uuid";
import wechat from "@/utils/wechat";
import md5 from "js-md5";

export default {
  name: "WechatPay",
  props: {
    userOrder: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      unSelect: require("@/assets/login/unselect@2x.png"),
      select: require("@/assets/login/select@2x.png"),
      choose: true,
      isClickPay: false
    };
  },
  created() {
    const query = this.$route.query;
    if (query.code && query.code !== localStorage.WECHAT_PAY_CODE) {
      localStorage.WECHAT_PAY_CODE = query.code;
      this.$store
        .dispatch("order/paymentPage", {
          params: {
            orderSn: query.orderSn,
            code: query.code,
            kind: 5
          }
        })
        .then(response => {
          const self = this;
          this.$store
            .dispatch("order/jsticket", {
              params: {
                url: encodeURIComponent(window.location.href)
              }
            })
            .then(res1 => {
              self.$store.dispatch("load/setCode", {
                code: 1
              });
              wx.config({
                debug: false,
                appId: res1.appId,
                timestamp: res1.timestamp,
                nonceStr: res1.nonceStr,
                signature: res1.signature,
                jsApiList: ["chooseWXPay"]
              });
              wx.ready(() => {
                self.$toast.clear();
                wx.chooseWXPay({
                  timestamp: response.timeStamp,
                  nonceStr: response.nonceStr,
                  package: response.package,
                  signType: response.signType,
                  paySign: response.paySign,
                  success() {
                    const secretKey = "a02ade6080c33cf74a39fe1a387f956a";
                    const random = uuidv1();
                    const md5Str =
                      secretKey +
                      "orderSn" +
                      query.orderSn +
                      "random" +
                      random +
                      secretKey;
                    const sign = md5(md5Str);
                    const data = {
                      orderSn: query.orderSn,
                      random,
                      sign
                    };
                    self.$store
                      .dispatch("order/paySuccessd", {
                        params: data
                      })
                      .then(() => {
                        self.$store.dispatch("load/setCode", {
                          code: 1
                        });
                        self.$router.push({
                          path: "/order/orderresult",
                          query: {
                            orderSn: query.orderSn
                          }
                        });
                      })
                      .catch(() => {
                        self.$store.dispatch("load/setCode", {
                          code: 1
                        });
                        self.$router.push({
                          path: "/order/orderresult",
                          query: {
                            orderSn: query.orderSn
                          }
                        });
                      });
                  },
                  fail() {
                    self.$store.dispatch("load/setCode", {
                      code: 1
                    });
                    self.$toast("支付失败");
                    const host = window.location.host;
                    window.location.replace(
                      `https://${host}${self.$route.path}?orderSn=${query.orderSn}`
                    );
                  },
                  cancel() {
                    self.$store.dispatch("load/setCode", {
                      code: 1
                    });
                    self.$toast("支付失败");
                    const host = window.location.host;
                    window.location.replace(
                      `https://${host}${self.$route.path}?orderSn=${query.orderSn}`
                    );
                  }
                });
              });
              wx.error(res => {
                self.$store.dispatch("load/setCode", {
                  code: 1
                });
                self.$toast.fail(res);
              });
            })
            .catch();
        })
        .catch(() => {
          this.$toast("支付失败！");
          const host = window.location.host;
          window.location.replace(
            `https://${host}${this.$route.path}?orderSn=${this.$route.query.orderSn}`
          );
        });
    }
  },
  methods: {
    clickChoose() {
      this.choose = !this.choose;
    },
    isWechatBrowser() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      return isWeixin;
    },
    goPay() {
      if (!this.choose) {
        this.$toast("请先选择支付方式");
        return;
      }
      if (!this.isClickPay) {
        this.isClickPay = true;
        if (this.isWechatBrowser()) {
          wechat();
        } else {
          this.$toast("请在微信中访问页面进行支付");
          this.isClickPay = false;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.pay_type {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 16px;
  font-size: 0;
  .pay_type_left {
    display: flex;
    align-items: center;
  }
  .wechat_icon {
    width: 24px;
    margin-right: 12px;
  }
  .wechat_font {
    font-size: 14px;
    color: #333;
    vertical-align: middle;
  }
  .select_icon {
    display: block;
    width: 18px;
  }
}

/* 悬浮底栏定位容器 */
.bottom_btn_wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 12px 16px;
  box-sizing: border-box;
  z-index: 100;
  /* 适配底部刘海安全区域 */
  padding-bottom: calc(12px + constant(safe-area-inset-bottom));
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

/* 确认支付/上传凭证按钮 */
.save_btn {
  width: 100%;
  background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  border-radius: 22px;
  padding: 13px 0;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(191, 146, 100, 0.15);
  line-height: 20px;
  &:active {
    opacity: 0.9;
  }
}
</style>
